// Components
import { Input } from 'components/form/inputs'

// Utils
import styles from './lastname.css'

type LastNameProps = {
  onReview: boolean
  isEditing: boolean
  lastName: string | undefined
}

const validateName = (value: string) => {
  let error
  if (value.length < 2) {
    error = 'Are you sure? This name seems too short'
  }
  return error
}

const LastName = (props: LastNameProps): JSX.Element => {
  const { onReview, isEditing, lastName } = props

  if (!isEditing) {
    return (
      <div className={styles.displayWrapper}>
        <div className={styles.textData}>{lastName}</div>
      </div>
    )
  }

  return (
    <div className={styles.editingWrapper}>
      <Input
        className={styles.inputField}
        id="last_name"
        name="last_name"
        type="text"
        label={onReview && isEditing ? '' : 'Last name'}
        autoComplete="given-name"
        validate={validateName}
      />
    </div>
  )
}

export default LastName
